import { useFeatureFlags } from 'components/FeatureFlagProvider/FeatureFlagProvider';
import { Session } from 'next-auth';
import { SessionContext, SessionContextValue, SessionProvider } from 'next-auth/react';
const unauthenticatedSession: SessionContextValue = {
  update: async () => null,
  data: null,
  status: 'unauthenticated'
};

/**
 * Wraps the SessionProvider with a feature flag.
 * If the feature flag is disabled, the session provider will be wrapped with an unauthenticated session.
 *
 * This can be removed and replaced by SessionProvider once we remove the feature flag .
 */
const SessionProviderWithFeatureFlag = ({
  children,
  session
}: {
  children: React.ReactNode;
  session: Session | null;
}) => {
  const {
    featureFlags
  } = useFeatureFlags();
  if (!featureFlags.loginEnabled) {
    return <SessionContext.Provider value={unauthenticatedSession}>
        {children}
      </SessionContext.Provider>;
  }
  return <SessionProvider session={session} data-sentry-element="SessionProvider" data-sentry-component="SessionProviderWithFeatureFlag" data-sentry-source-file="SessionProviderWithFeatureFlag.tsx">{children}</SessionProvider>;
};
export default SessionProviderWithFeatureFlag;